export default __webpack_public_path__ + "static/1030-59ab297241730b3685a8012a43e9e9f8.gif";